var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"lang-select"},_vm._l((_vm.locales),function(lang){return _c('nuxt-link',{key:lang,class:{lang:true,current:_vm.$i18n.locale==lang},attrs:{"lang":lang,"to":_vm.switchLocalePath(lang)}},[_vm._v("\n    "+_vm._s(_vm.$t(`languages.${lang}`))+"\n  ")])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }